import { render, staticRenderFns } from "./PrescriptionItemSelect.vue?vue&type=template&id=0f587266&scoped=true"
import script from "./PrescriptionItemSelect.vue?vue&type=script&lang=ts"
export * from "./PrescriptionItemSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f587266",
  null
  
)

export default component.exports